module.exports = __webpack_public_path__ + "img/ky_business.c3fe62e6.png";